const styles = theme => ({
    grid: {
        padding: "0 15px !important"
    }
});
    
export default styles;